<div class="deploy">

  <kendo-gridlayout
    [cols]="['','']"
    [gap]="{ rows: 8, cols: 8 }"
    >
    <kendo-gridlayout-item [col]="1" [colSpan]="2" [rowSpan]="2">
      <div class="example-box" style="display:flex; justify-content: space-between; flex-wrap: wrap;">
        <div>
          Read:
          <a href="https://learn.flowstudio.app/migrate-flows" target="learn"><fa-icon icon="user-graduate" style="margin-right:5px;" title="Learn"></fa-icon>Migrate Power Automate Flows</a>&nbsp;
          <a href="https://learn.flowstudio.app/migrate-flows/advanced-tip" target="learn"><fa-icon icon="user-graduate" style="margin-right:5px;" title="Learn"></fa-icon>Advanced Tip for Flow Migration</a>&nbsp;
        </div>
        <div>
          <span class="text-sm text-slate-500">Migrate is a <span class="pro-box"></span> subscription feature</span>
        </div>
      </div>
    </kendo-gridlayout-item>
    <!-- <kendo-gridlayout-item [col]="1" [colSpan]="2" >
    <h3>Migration Plan</h3>
  </kendo-gridlayout-item> -->
  <kendo-gridlayout-item [col]="1" [colSpan]="2" [rowSpan]="2">
    <div class='grid-wrapper' kendoTooltip>
      <!-- <h3>Replacement Mapping</h3> -->
      <kendo-grid #grid
        [data]="this.deployPlan.items"

        (cellClick)="cellClickHandler($event)"
        (cellClose)="cellCloseHandler($event)"
        (cancel)="cancelHandler($event)"
        (save)="saveHandler($event)"
        (remove)="removeHandler($event)"
        (add)="addHandler($event)"
        [navigable]="true"

        [kendoGridSelectBy]
        [(selectedKeys)]="selection"

        >
        <ng-template kendoGridToolbarTemplate position="top">
          <kendo-combobox

            [data]="this.plans"
            [textField]="'name'"
            [valueField]="'name'"
            [(ngModel)]="this.selectedPlan"
            [valuePrimitive]="true"
            [allowCustom]="true"
            (valueChange)="planChange($event)"
            [loading]="this.loading"
            [style.width.px]="300"

            #selectedPlanAnchor
            title="Select an existing plan or enter a new name to start"
            >
          </kendo-combobox>
          <button kendoButton class='k-button'
            type="button"
            [icon]="'plus'"
            (click)="saveChanges(grid);"
            [disabled]="!!this.selectedPlan"
            title="Select an existing plan or enter a new name to start"
          >New Plan</button>
          <button kendoButton class='k-button'
            type="button"
            [icon]="'save'"
            (click)="saveChanges(grid);"
            [disabled]="!this.selectedPlan"
          >Save Plan</button>

          <!-- <button kendoButton class='k-button' [icon]="'close'" (click)="cancelChanges(grid);" type="button">Cancel Changes</button> -->
          <button kendoButton class='k-button' [icon]="'arrow-60-right'" (click)="deploy()" type="button"
          [disabled]="!this.selectedPlan || this.deployPlan.items.length == 0 || !this.deployPlan.environmentSource || !this.deployPlan.environmentDestination || this.loading || this.sourceLoading || this.destinationLoading">Run Plan</button>


          <button kendoButton type="button" [disabled]="this.loading || this.sourceLoading || this.destinationLoading" (click)="editPlanJson()" ><span class="ms-Icon ms-Icon--TextDocumentSettings"></span>&nbsp;Export/Import</button>

          <button kendoButton type="button" [disabled]="!this.selectedPlan || this.deployPlan.items.length == 0 || !this.deployPlan.environmentSource || !this.deployPlan.environmentDestination || this.loading || this.sourceLoading || this.destinationLoading" (click)="editSelectedPlanJson()" ><span class="ms-Icon ms-Icon--TextDocumentSettings"></span>&nbsp;Export Selected Plan</button>
        </ng-template>
        <kendo-grid-checkbox-column [width]="30" [style]="{'max-width':'30px', 'min-width':'30px', 'padding':'4px 4px'}" [headerStyle]="{'max-width':'30px', 'padding':'4px 4px'}" class="cell"></kendo-grid-checkbox-column>

        <!-- <kendo-grid-column field="Type" title="Type"></kendo-grid-column>
        <kendo-grid-column field="Name" title="Name"></kendo-grid-column> -->
        <kendo-grid-column field="flowSource" title="Source">
          <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
            <span>{{column.title}}</span>&nbsp;
            <kendo-combobox
              [data]="this.environments"

              [textField]="'displayName'"
              [valueField]="'name'"
              [valuePrimitive]="true"

              [(ngModel)]="this.deployPlan.environmentSource"
              (valueChange)="this.environmentSourceChange()"

              style="width:60%"
              [disabled]="!this.selectedPlan"
              [loading]="this.loading"
              >
              <ng-template kendoComboBoxItemTemplate let-dataItem>
                <span>{{ dataItem.displayName }}</span>
              </ng-template>
            </kendo-combobox>
            @if (this.sourceLoading) {
              <span class="k-icon k-i-loading"></span>
            }
            @if (!this.sourceLoading) {
              <button kendoButton class='k-button' icon="refresh" type="button" (click)="this.environmentSourceChange(true)" [disabled]="this.loading" ></button>
            }

          </ng-template>
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>
              @if (getFlow(dataItem.flowSource); as flow) {
                <img [src]='this.getSafeUrl(flow.icon)' [style.background-color]="flow.backgroundColor" style='width:20px; height:20px; vertical-align:middle;' />&nbsp;
                <span style="margin-right: 5px;">{{flow.displayName}}</span>
                @if (flow.type == 'flow') {
                  <a href="{{this.apiRoot}}/manage/environments/{{flow.environment}}/flows/{{flow.sharingType=='Coauthor'?'shared/':''}}{{flow.name}}/details"
                    title="Maker Portal: /manage/environments/{{flow.environment}}/flows/{{flow.name}}/details" target="_blank">
                    <i class="ms-Icon ms-Icon--Link" style='margin-right: 5px; font-weight:bold;' aria-hidden="true"></i>
                  </a>
                }
                <!-- <a href="https://make.powerapps.com/environments/{{flow.environment}}/apps/{{flow.name}}/details"
                title="Maker Portal: /environments/{{flow.environment}}/apps/{{flow.name}}/details" target="_blank" *ngIf="flow.type == 'powerapp'">
                <span class='k-icon k-i-hyperlink-open-sm' style="margin-right: 5px;"></span>
              </a> -->
            }
            @if (getFlow(dataItem.flowSource) == null) {
              @if (this.sourceLoading) {
                <span class="k-icon k-i-loading" title="loading source environment details."></span>
              }
              <span>{{ dataItem.flowSource }}</span>
            }
          </span>
        </ng-template>
        <ng-template kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup">
          <!-- <kendo-dropdownlist
          [defaultItem]="{CategoryID: null, CategoryName: 'Test null item'}"
          [data]="categories"
          textField="CategoryName"
          valueField="CategoryID"
          [valuePrimitive]="true"
          [formControl]="formGroup.get('CategoryID')"
          >
        </kendo-dropdownlist> -->
        <kendo-combobox
          [data]="this.viewSource"

          [textField]="'displayName'"
          [valueField]="'name'"
          [valuePrimitive]="true"

          [formControl]="formGroup.get('flowSource')"

          (valueChange)="sourceChange($event)"

          [filterable]="true"
          (filterChange)="filterChangeSource($event)"
          [loading]="this.sourceLoading"
          >
          <ng-template kendoComboBoxItemTemplate let-dataItem>
            <span><img [src]='this.getSafeUrl(dataItem.triggerIcon)' [style.background-color]="dataItem.backgroundColor" style='width:20px; height:20px; vertical-align:middle;' />&nbsp;{{ dataItem.displayName }}</span>
          </ng-template>
        </kendo-combobox>

        <!-- <kendo-popup
        [anchor]="ddl.element"
        *ngIf="formGroup.get(column.field).invalid && !(isNew && formGroup.get(column.field).untouched)"
        popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg"
        >
        <span class="k-icon k-i-warning"></span>
        Category is required
      </kendo-popup> -->
    </ng-template>
    <ng-template kendoGridFooterTemplate let-column -let-columnIndex>
      <button kendoGridAddCommand type="button" [disabled]="!this.selectedPlan || !this.deployPlan.environmentSource || !this.deployPlan.environmentDestination || this.loading || this.sourceLoading || this.destinationLoading"><i class="ms-Icon ms-Icon--CirclePlus" style='font-weight:bold;' aria-hidden="true"></i>&nbsp;Add Flow</button>&nbsp;

      <button kendoButton class='k-button' [icon]="'arrow-60-right'" (click)="deploy()" type="button"
      [disabled]="!this.selectedPlan || this.deployPlan.items.length == 0 || !this.deployPlan.environmentSource || !this.deployPlan.environmentDestination || this.loading || this.sourceLoading || this.destinationLoading">Run Plan</button>&nbsp;

      <button kendoButton class='k-button' [icon]="'arrow-60-right'" (click)="deploy(true)" type="button"
      [disabled]="this.selection.length == 0 || !this.selectedPlan || this.deployPlan.items.length == 0 || !this.deployPlan.environmentSource || !this.deployPlan.environmentDestination || this.loading || this.sourceLoading || this.destinationLoading">Migrate Selected Items ({{this.selection.length}})</button>

      <!-- <button kendoButton type="button" [disabled]="!this.selectedPlan || !this.deployPlan.environmentSource || !this.deployPlan.environmentDestination || this.loading || this.sourceLoading || this.destinationLoading"><span class="k-icon k-i-plus"></span>&nbsp;Add PowerApp</button>     -->
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="flowDestination" title="Destination">
    <ng-template kendoGridHeaderTemplate let-column let-columnIndex="columnIndex">
      <span>{{column.title}}</span>&nbsp;
      <kendo-combobox
        [data]="this.environments"

        [textField]="'displayName'"
        [valueField]="'name'"
        [valuePrimitive]="true"

        [(ngModel)]="this.deployPlan.environmentDestination"
        (valueChange)="this.environmentDestinationChange()"

        style="width:60%"
        [disabled]="!this.selectedPlan"
        [loading]="this.loading"
        >
        <ng-template kendoComboBoxItemTemplate let-dataItem>
          <span>{{ dataItem.displayName }}</span>
        </ng-template>
      </kendo-combobox>
      @if (this.destinationLoading) {
        <span class="k-icon k-i-loading"></span>
      }
      @if (!this.destinationLoading) {
        <button kendoButton class='k-button' icon="refresh" type="button" (click)="this.environmentDestinationChange(true)" [disabled]="this.loading" ></button>
      }

    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      @if (getDestinationFlow(dataItem.flowDestination); as flow) {
        <img [src]='this.getSafeUrl(flow.icon)' [style.background-color]="flow.backgroundColor" style='width:20px; height:20px; vertical-align:middle;' />&nbsp;
        <span style="margin-right: 5px;">{{flow.displayName}}</span>
        @if (flow.type == 'flow') {
          <a href="{{this.apiRoot}}/manage/environments/{{flow.environment}}/flows/{{flow.sharingType=='Coauthor'?'shared/':''}}{{flow.name}}/details"
            title="Maker Portal: /manage/environments/{{flow.environment}}/flows/{{flow.name}}/details" target="_blank">
            <i class="ms-Icon ms-Icon--Link" style='margin-right: 5px; font-weight:bold;' aria-hidden="true"></i>
          </a>
        }
        <!-- <a href="https://make.powerapps.com/environments/{{flow.environment}}/apps/{{flow.name}}/details"
        title="Maker Portal: /environments/{{flow.environment}}/apps/{{flow.name}}/details" target="_blank" *ngIf="flow.type == 'powerapp'">
        <span class='k-icon k-i-hyperlink-open-sm' style="margin-right: 5px;"></span>
      </a> -->
    }
    @if (getDestinationFlow(dataItem.flowDestination) == null) {
      @if (this.destinationLoading) {
        <span class="k-icon k-i-loading" title="loading destination environment details."></span>
      }
      <span>@if (!this.destinationLoading) {
        <span class="ms-Icon ms-Icon--PageAdd" title="Will Create New Flow '{{dataItem.flowDestination}}'"></span>
      }&nbsp;{{ dataItem.flowDestination }}</span>
    }
  </ng-template>
  <ng-template kendoGridEditTemplate
    let-dataItem="dataItem"
    let-column="column"
    let-formGroup="formGroup">
    <!-- <kendo-dropdownlist
    [defaultItem]="{CategoryID: null, CategoryName: 'Test null item'}"
    [data]="categories"
    textField="CategoryName"
    valueField="CategoryID"
    [valuePrimitive]="true"
    [formControl]="formGroup.get('CategoryID')"
    >
  </kendo-dropdownlist> -->
  <kendo-combobox
    [data]="this.viewDestination"

    [textField]="'displayName'"
    [valueField]="'name'"
    [valuePrimitive]="true"
    [allowCustom]="true"

    [formControl]="formGroup.get('flowDestination')"

    (valueChange)="destinationChange($event)"

    [filterable]="true"
    (filterChange)="filterChangeDestination($event)"
    [loading]="this.destinationLoading"
    >
    <ng-template kendoComboBoxItemTemplate let-dataItem>
      <span><img [src]='this.getSafeUrl(dataItem.triggerIcon)' [style.background-color]="dataItem.backgroundColor" style='width:20px; height:20px; vertical-align:middle;' />&nbsp;{{ dataItem.displayName }}</span>
    </ng-template>
  </kendo-combobox>

  <!-- <kendo-popup
  [anchor]="ddl.element"
  *ngIf="formGroup.get(column.field).invalid && !(isNew && formGroup.get(column.field).untouched)"
  popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg"
  >
  <span class="k-icon k-i-warning"></span>
  Category is required
</kendo-popup> -->
</ng-template>
</kendo-grid-column>
<kendo-grid-command-column title="" [width]="260">
  <ng-template kendoGridCellTemplate let-isNew="isNew" let-formGroup="formGroup" let-dataItem="dataItem">
    <button kendoButton (click)="doDiff(dataItem)"><span class="ms-Icon ms-Icon--DiffSideBySide"></span>&nbsp;Diff</button>
    <button kendoGridRemoveCommand><span class="ms-Icon ms-Icon--Delete"></span>&nbsp;Remove</button>
    <button kendoGridSaveCommand [disabled]="formGroup?.invalid">{{ isNew? 'Add': 'Update'}}</button>
    <button kendoGridCancelCommand>Cancel</button>
  </ng-template>
</kendo-grid-command-column>

<ng-template kendoGridDetailTemplate let-dataItem="dataItem">

  <div>
    <kendo-grid #rgrid
      [data]="dataItem.replacements"

      (cellClick)="rcellClickHandler($event)"
      (cellClose)="rcellCloseHandler($event)"
      (cancel)="cancelHandler($event)"
      (save)="rsaveHandler($event, dataItem)"
      (remove)="rremoveHandler($event, dataItem)"
      (add)="raddHandler($event)"
      [navigable]="true"
      >
      <ng-template kendoGridToolbarTemplate>
        <button class='k-button' kendoButton (click)="wizard(dataItem)" [disabled]="this.loading || this.sourceLoading || this.destinationLoading" ><fa-icon icon="magic"></fa-icon>&nbsp;Wizard</button>
        <button kendoGridAddCommand [disabled]="this.loading || this.sourceLoading || this.destinationLoading"><span class="ms-Icon ms-Icon--Add"></span>Add new</button>
        <!-- <button class='k-button' [disabled]="hasChanges()" (click)="saveChanges(rgrid);">Save Changes</button>
        <button class='k-button' [disabled]="hasChanges()" (click)="cancelChanges(rgrid);">Cancel Changes</button> -->
        <!-- <button class='k-button' (click)="deploy()">Run</button> -->
      </ng-template>
      <kendo-grid-column field="type" title="Type" [width]="75">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span title="{{dataItem?.path?.join('.')}}">{{dataItem.type}}</span>
        </ng-template>
        <ng-template kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup">
          <span title="{{dataItem?.path?.join('.')}}">{{dataItem.type}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="name" title="Name" [width]="75">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span title="{{dataItem?.path?.join('.')}}">{{dataItem.name}}</span>
        </ng-template>
        <ng-template kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup">
          <span title="{{dataItem?.path?.join('.')}}">{{dataItem.name}}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="source" title="Source" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.type != 'Connection') {
            {{  dataItem.source }}
          }
          @if (dataItem.type == 'Connection') {
            @if (getSourceConnection(dataItem.source); as connection) {
              <img [src]='this.getSafeUrl(connection.iconUri)' style='width:20px; height:20px; vertical-align:middle;' />&nbsp;
              <span style="margin-right: 5px;" [title]="dataItem.source">{{connection.displayName}}</span>
            }
            @if (getSourceConnection(dataItem.source) == null) {
              <span><span class="k-icon k-i-track-changes-enable"></span>&nbsp;{{ dataItem.source }}</span>
            }
          }
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="destination" title="Destination" [width]="200">
        <ng-template kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup">
          @if (!(dataItem.type == 'Connection') && !(dataItem.type == 'Override') && !(dataItem.type == 'State') && !(dataItem.type == 'Text' && dataItem.name == 'URL')) {
            <input kendoTextBox type="text"
              [formControl]="formGroup.get('destination')"
              >
          }
          @if (dataItem.type == 'Text' && dataItem.name == 'URL' ) {
            <kendo-combobox
              [data]="this.viewURLs"
              [textField]="'triggerUrl'"
              [valueField]="'triggerUrl'"
              [formControl]="formGroup.get('destination')"
              [valuePrimitive]="true"
              [allowCustom]="true"
              >
              <ng-template kendoComboBoxItemTemplate let-dataItem>
                <span><img [src]='this.getSafeUrl(dataItem.triggerIcon)' style='width:20px; height:20px; vertical-align:middle;' />&nbsp;<b>{{ dataItem.displayName }}</b>&nbsp;{{ dataItem.triggerUrl }}</span>
              </ng-template>
            </kendo-combobox>
          }
          @if (dataItem.type == 'Connection' ) {
            <kendo-combobox
              [data]="this.viewDestinationConnections"
              [textField]="'displayName'"
              [valueField]="'name'"
              [valuePrimitive]="true"
              [formControl]="formGroup.get('destination')"
              >
              <ng-template kendoComboBoxItemTemplate let-dataItem>
                <span><img [src]='this.getSafeUrl(dataItem.iconUri)' style='width:20px; height:20px; vertical-align:middle;' />&nbsp;{{ dataItem.displayName }}</span>
              </ng-template>
            </kendo-combobox>
          }
          @if (dataItem.type == 'State' ) {
            <kendo-dropdownlist
              [data]="['Default', 'Started', 'Stopped']"
              [formControl]="formGroup.get('destination')"
              >
            </kendo-dropdownlist>
          }
          @if (dataItem.type == 'Override' ) {
            <kendo-dropdownlist
              [data]="['Force', 'Skip']"
              [formControl]="formGroup.get('destination')"
              >
            </kendo-dropdownlist>
          }

        </ng-template>

        <ng-template kendoGridCellTemplate let-dataItem>
          @if (dataItem.type != 'Connection' && dataItem.type != 'State' && dataItem.type != 'Override') {
            {{  dataItem.destination }}
          }
          @if (dataItem.type == 'State') {
            <span title="Default: (keep existing Flow's state, stopped for new Flows); Stopped: always stop; Started: always start.">{{  dataItem.destination }}</span>
          }
          @if (dataItem.type == 'Override') {
            <span title="Override Yes is needed to force update to source itself.">{{  dataItem.destination }}</span>
          }
          @if (dataItem.type == 'Connection') {
            @if (getConnection(dataItem.destination); as connection) {
              <img [src]='this.getSafeUrl(connection.iconUri)' style='width:20px; height:20px; vertical-align:middle;' />&nbsp;
              <span style="margin-right: 5px;" [title]="dataItem.destination">{{connection.displayName}}</span>
              <!-- <a href="{{this.apiRoot}}/manage/environments/{{flow.environment}}/flows/{{flow.sharingType=='Coauthor'?'shared/':''}}{{flow.flowName}}/details"
              title="Maker Portal: /manage/environments/{{flow.environment}}/flows/{{flow.flowName}}/details" target="_blank">
              <span class='k-icon k-i-hyperlink-open-sm' style="margin-right: 5px;"></span>
            </a>     -->
          }
          @if (getConnection(dataItem.destination) == null) {
            <span class="k-icon k-i-track-changes-enable" title="need a connection"></span>
            <span>&nbsp;{{ dataItem.destination }}</span>&nbsp;
            <a href="https://learn.flowstudio.app/flow-migration"><fa-icon icon="user-graduate" style="margin-right:5px;" title="follow these steps to create new connection references in the destination environment."></fa-icon></a>
          }
        }
      </ng-template>

    </kendo-grid-column>
    <kendo-grid-column field="description" title="Description" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div style="text-overflow: ellipsis; overflow:hidden; white-space: nowrap;" title="{{dataItem.description}}">
          {{  dataItem.description }}
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-command-column title="" [width]="90">
      <ng-template kendoGridCellTemplate let-isNew="isNew" let-dataItem>
        <button kendoGridRemoveCommand>Remove</button>
        <button kendoGridSaveCommand>Add</button>
        <button kendoGridCancelCommand>Cancel</button>
        <!-- <button kendoButton (click)="this.ignore(dataItem, rgrid)">Ignore</button> -->
      </ng-template>
    </kendo-grid-command-column>

  </kendo-grid>

</div>

</ng-template>

</kendo-grid>
@if (this.loading) {
  <div class="loading">
    <div class="k-i-loading"></div>
  </div>
}
</div>
</kendo-gridlayout-item>
</kendo-gridlayout>
<kendo-gridlayout-item [col]="1" [colSpan]="2" [rowSpan]="2">
  @if (this.results.length > 0) {
    <div>
      <h3>Migration Results</h3>
      <ul>
        @for (result of this.results; track result) {
          <li>{{result}}</li>
        }
      </ul>
    </div>
  }
</kendo-gridlayout-item>

<div>
  <!-- {{  this.deployPlan | json }}
  {{ this.sourceLoading }}
  {{ this.destinationLoading }}
  {{ this.destinationFlows.length }}
  {{ this.sourceFlows.length }} -->
</div>
</div>
